/**
 * Deformed-shape helper for the FEA stress view. Kept as a pure, dependency-
 * free function so the load-bearing invariant is unit-testable without a GPU:
 * the input `orig` array is the EVALUATOR's shared positions buffer (also read
 * by exports, snapping, and re-solves), so it must NEVER be mutated in place —
 * we always return a fresh array. A refactor that writes back into `orig`
 * would silently corrupt exported geometry; the test asserts byte-identity of
 * the input after the call.
 */
export function deformedPositions(
  orig: Float32Array,
  displacement: Float32Array,
  scale: number,
): Float32Array {
  const out = new Float32Array(orig.length);
  for (let i = 0; i < orig.length; i++) {
    out[i] = orig[i]! + (displacement[i] ?? 0) * scale;
  }
  return out;
}
